// extracted by mini-css-extract-plugin
export var errorIcon = "_jf-1";
export var nameLogo = "_jf-0";